// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"135":"4d90ba82","906":"24c4fcbf","947":"24c4fcbf"}[chunkId] + ".chunk.css";
};